import { mdiBellOutline, mdiHome, mdiMessage, mdiNewspaperVariantMultipleOutline, mdiRocketLaunchOutline } from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'token-dashboard',
	},
	{
		icon: mdiRocketLaunchOutline,
		title: 'token.sale.menu',
		module: 'MGT,token-sale',
		children: [
			{
				title: 'token.sale.list.title',
				to: 'token-sale-list',
			},
		],
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'token-messages-list',
		module: 'MGT,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'token-newsletter-list',
		module: 'MGT,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGT,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'token-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
